/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateServerForm,
  CreateServerForm$Outbound,
  CreateServerForm$outboundSchema,
} from "../components/createserverform.js";

export type CreateRemoteMcpServerAndMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateRemoteMcpServerAndMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateRemoteMcpServerAndMcpServerSecurity = {
  option1?: CreateRemoteMcpServerAndMcpServerSecurityOption1 | undefined;
  option2?: CreateRemoteMcpServerAndMcpServerSecurityOption2 | undefined;
};

export type CreateRemoteMcpServerAndMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createServerForm: CreateServerForm;
};

/** @internal */
export type CreateRemoteMcpServerAndMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateRemoteMcpServerAndMcpServerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CreateRemoteMcpServerAndMcpServerSecurityOption1$Outbound,
    CreateRemoteMcpServerAndMcpServerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createRemoteMcpServerAndMcpServerSecurityOption1ToJSON(
  createRemoteMcpServerAndMcpServerSecurityOption1:
    CreateRemoteMcpServerAndMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    CreateRemoteMcpServerAndMcpServerSecurityOption1$outboundSchema.parse(
      createRemoteMcpServerAndMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateRemoteMcpServerAndMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateRemoteMcpServerAndMcpServerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CreateRemoteMcpServerAndMcpServerSecurityOption2$Outbound,
    CreateRemoteMcpServerAndMcpServerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createRemoteMcpServerAndMcpServerSecurityOption2ToJSON(
  createRemoteMcpServerAndMcpServerSecurityOption2:
    CreateRemoteMcpServerAndMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    CreateRemoteMcpServerAndMcpServerSecurityOption2$outboundSchema.parse(
      createRemoteMcpServerAndMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateRemoteMcpServerAndMcpServerSecurity$Outbound = {
  Option1?:
    | CreateRemoteMcpServerAndMcpServerSecurityOption1$Outbound
    | undefined;
  Option2?:
    | CreateRemoteMcpServerAndMcpServerSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const CreateRemoteMcpServerAndMcpServerSecurity$outboundSchema:
  z.ZodMiniType<
    CreateRemoteMcpServerAndMcpServerSecurity$Outbound,
    CreateRemoteMcpServerAndMcpServerSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        CreateRemoteMcpServerAndMcpServerSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        CreateRemoteMcpServerAndMcpServerSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function createRemoteMcpServerAndMcpServerSecurityToJSON(
  createRemoteMcpServerAndMcpServerSecurity:
    CreateRemoteMcpServerAndMcpServerSecurity,
): string {
  return JSON.stringify(
    CreateRemoteMcpServerAndMcpServerSecurity$outboundSchema.parse(
      createRemoteMcpServerAndMcpServerSecurity,
    ),
  );
}

/** @internal */
export type CreateRemoteMcpServerAndMcpServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateServerForm: CreateServerForm$Outbound;
};

/** @internal */
export const CreateRemoteMcpServerAndMcpServerRequest$outboundSchema:
  z.ZodMiniType<
    CreateRemoteMcpServerAndMcpServerRequest$Outbound,
    CreateRemoteMcpServerAndMcpServerRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      createServerForm: CreateServerForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
        createServerForm: "CreateServerForm",
      });
    }),
  );

export function createRemoteMcpServerAndMcpServerRequestToJSON(
  createRemoteMcpServerAndMcpServerRequest:
    CreateRemoteMcpServerAndMcpServerRequest,
): string {
  return JSON.stringify(
    CreateRemoteMcpServerAndMcpServerRequest$outboundSchema.parse(
      createRemoteMcpServerAndMcpServerRequest,
    ),
  );
}
